import React, { useState } from "react";
import "./style.scss";
import eyeIcon from "../../../assets/icons/eye-icon-white.svg";
import eyeSlashedIcon from "../../../assets/icons/eye-slashed-icon-white.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import logoIcon from "../../../assets/icons/acg-logo.png";
const ResetPasswordForm = () => {
  const inputs = {
    newpassword: "",
    confirmpassword: "",
  };

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);

  const schema = Yup.object().shape({
    newpassword: Yup.string().required("Password is required"),
    confirmpassword: Yup.string().required("Password is required"),
  });

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: inputs,
      validationSchema: schema,
      onSubmit: async (values) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
          formData.append(key, values[key]);
        });
      },
    });

  return (
    <div className="resetpasswordform-container">
      <div className="resetpasswordform-wrapper">
        <div className="company-logo">
          <img src={logoIcon} alt="company-logo" />
        </div>
        <div className="resetpasswordform-form-info">
          <h2 className="form-header">Reset password</h2>
          <p className="form-caption">Let's reset your new password</p>
        </div>
        <form className="resetpasswordform-innnercontainer">
          <div
            className="resetpasswordform-subcontainer-form"
            style={{
              gap:
                (touched.newpassword && errors.newpassword) ||
                (touched.confirmpassword && errors.confirmpassword)
                  ? "20px"
                  : "30px",
            }}
          >
            <div className="input-wrapper">
              <p className="input-label">Enter new Password</p>
              <label
                className={`${`resetpasswordform-container-input `}${
                  touched.newpassword &&
                  errors.newpassword &&
                  "form-empty-input"
                }`}
                htmlFor="newpassword"
              >
                {/* <img src={lockIcon} alt="" /> */}
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  className="resetpasswordform-input-box"
                  name="newpassword"
                  value={values.newpassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter New Password"
                  id="newpassword"
                />
                <img
                  style={{ cursor: "pointer" }}
                  src={isPasswordVisible ? eyeIcon : eyeSlashedIcon}
                  alt=""
                  onClick={() => setIsPasswordVisible((prev) => !prev)}
                />{" "}
              </label>
            </div>
            {touched.newpassword && errors.newpassword && (
              <div className="form-error-message">{errors.newpassword}</div>
            )}
            <div className="input-wrapper">
              <p className="input-label">Confirm new Password</p>
              <label
                className={`${`resetpasswordform-container-input `}${
                  touched.confirmpassword &&
                  errors.confirmpassword &&
                  "form-empty-input"
                }`}
                htmlFor="confirmpassword"
              >
                {/* <img src={lockIcon} alt="" /> */}
                <input
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  className="resetpasswordform-input-box"
                  name="confirmpassword"
                  value={values.confirmpassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Confirm Password"
                  id="confirmpassword"
                />
                <img
                  style={{ cursor: "pointer" }}
                  src={isConfirmPasswordVisible ? eyeIcon : eyeSlashedIcon}
                  alt=""
                  onClick={() => setIsConfirmPasswordVisible((prev) => !prev)}
                />{" "}
              </label>
            </div>
            {touched.confirmpassword && errors.confirmpassword && (
              <div className="form-error-message">{errors.confirmpassword}</div>
            )}
          </div>
          <div className="resetpasswordform-submit-options">
            <button className="submit-button standard-button">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
